export const GET_ACTOR = 'getActor'
export const GET_ACTOR_BY_SETTING = 'getActorBySetting'
export const GET_ACTOR_BY_SEND_MESSAGE = 'getActorBySendMessage'
